<template>
    <div>
      <div class="mt-3 p-2">
        <b-container fluid class="mb-2">
          <b-alert variant="success" v-if="success" show> {{ success }}</b-alert>
          <b-form @submit.prevent="submitForm" enctype="multipart/form-data">
            <div class="row">
              <div class="col-md-6">
               
                <b-form-group
                  id="input-group-2"
                  label="Select Activity type :"
                  label-for="input-2"
                >
                  <b-form-select
                    v-model="form._activityTypeID"
                    :options="activitiesTypes"
                    value-field="_id"
                    text-field="name"
                    disabled
                  >
                    <template #first>
                      <b-form-select-option value="" disabled
                        >Select Activity Category</b-form-select-option
                      >
                    </template>
                  </b-form-select>
                </b-form-group>
  
                <b-form-group
                  id="input-group-2"
                  label="Description:"
                  label-for="input-2"
                >
                  <b-form-textarea
                    id="input-2"
                    v-model="form.description"
                    placeholder="Enter description..."
                    rows="5"
                    max-rows="8"
                  ></b-form-textarea>
                </b-form-group>
                <div class="row">
                  <div class="col-md-12">
                    <b-form-group
                      id="input-group-1"
                      label="Start Date:"
                      label-for="input-1"
                    >
                      <b-form-datepicker
                        id="example-datepicker"
                        v-model="form.start_date"
                        class="mb-2"
                      ></b-form-datepicker>
                    </b-form-group>
                  </div>
                  <div class="col-md-12">
                    <b-form-group
                      id="input-group-1"
                      label="End Date:"
                      label-for="input-1"
                    >
                      <b-form-datepicker
                        id="example-datepicker1"
                        v-model="form.end_date"
                        class="mb-2"
                      ></b-form-datepicker>
                    </b-form-group>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-6">
                    <b-form-group
                      id="input-group-1"
                      label="Status:"
                      label-for="input-1"
                    >
                      <select
                        v-model="form.activity_status"
                        required="required"
                        class="form-control"
                      >
                        <option value="">Select Activity status</option>
                        <option value="1">Pending</option>
                        <option value="2">In Progress</option>
                        <option value="3">Completed</option>
                      </select>
                    </b-form-group>
                  </div>
                  <div class="col-md-6">
                    <b-form-group
                      id="input-group-2"
                      label="Progress:"
                      label-for="input-2"
                    >
                      <select
                        v-model="form.progress"
                        required="required"
                        class="form-control"
                      >
                        <option value="">Select Activity status</option>
                        <option value="0">0%</option>
                        <option value="25">25%</option>
                        <option value="50">50%</option>
                        <option value="75">75%</option>
                        <option value="100">100%</option>
                      </select>
                    </b-form-group>
                  </div>
                </div>
              </div>
              <div class="col-md-6">
                <div class="row">
                  <div class="col-md-6">
                    <b-form-group
                      id="input-group-1"
                      label="Frequency:"
                      label-for="input-1"
                    >
                      <select
                        v-model="form.frequency"
                        class="form-control"
                      >
                        <option value="">Select Frequency</option>
                        <option value="Daily">Daily</option>
                        <option value="Monthly">Monthly</option>
                        <option value="Yearly">Yearly</option>
                        <option value="Half-yearly">Half-yearly</option>
                        <option value="Quarter-yearly">Quarter-yearly</option>
                        <option value="On need basis">On need basis</option>
                      </select>
                    </b-form-group>
                  </div>
                  <div class="col-md-6">
                    <b-form-group
                      id="input-group-2"
                      label="No of Workers:"
                      label-for="input-2"
                    >
                      <b-form-input
                        id="input-2"
                        v-model="form.no_of_worker"
                        placeholder="Enter No of Workers"
                        required
                      ></b-form-input>
                    </b-form-group>
                  </div>
                </div>
                <b-form-group
                  id="input-group-2"
                  label="Resource:"
                  label-for="input-2"
                >
                  <b-form-input
                    id="input-2"
                    v-model="form.resources"
                    placeholder="Enter Resource"
                    required
                  ></b-form-input>
                </b-form-group>
                <b-form-group
                  id="input-group-2"
                  label="Image:"
                  label-for="input-2"
                >
                <div class="row mb-4">
                  <div v-for="(img,i) in form.image" :key="i" style="width: 100px;margin-right:10px">
                    <img :src="img" alt=""  width="100px" height="100px">
                    <br>
                    <button class="btn btn-danger btn-sm btn-block" @click="removeImage(i)" type="button">
                    <i class="fa fa-trash"></i></button>
                  </div>
                </div>
                 
                 <input type="file" multiple @change="uploadImage"
                 :disabled="form.image.length >= 5" ref="multifileupload">
                
                </b-form-group>
               
              </div>
              <div class="col-md-12 ">
                <button type="submit" class="btn btn-sm btn-success"   :disabled="!hasFormChanged">Update</button>
                <button 
                v-if="!approvalStatus"
                  type="button" 
                  class="btn btn-sm btn-primary" 
              :disabled="isApproveDisable"
                  @click="approveForm()"
                >
                  Approve
                </button>
              </div>
            </div>
          </b-form>
        </b-container>
      </div>
    </div>
</template>

<script>
import axios from 'axios';

export default {
  data() {
    return {
      approvalStatus:null,
      form: {
        _activityTypeID: '',
        description: '',
        start_date: '',
        end_date: '',
        frequency: '',
        no_of_worker: '',
        resources: '',
        image: [],
        image_url:[],
        assignment_level: '',
        notification: true,
        visible: true,
        activity_status: '',
        progress: '',
      },
    
      originalForm: {},
      activitiesTypes:[],
      projects: [],
      zones: [],
      plots: [],
      success: false,
      isApproveDisable:false,
    };
  },

  computed: {
    hasFormChanged() {
      return !this.isFormEqual(this.form, this.originalForm);
    }
  },

  watch: {
    form: {
      handler() {
      },
      deep: true
    },
      hasFormChanged(newVal) {
    if(newVal==true) this.isApproveDisable = newVal;
  },
  },

  mounted() {
    this.getActivityType();  
    this.setupdata();
  },

  methods: {
    setupdata() {
      let workOrderId = this.$route.params.workOrderId;
      window.axios.get('/work-orders/view/' + workOrderId).then((resp) => {
        console.log(resp);
        if (resp.data.success) {
       
          const data = resp.data.data;
             this.approvalStatus=data.status
          this.form._activityTypeID = data._activity_type._id;
          this.form.description = data.description;
          this.form.start_date = data.start_date;
          this.form.end_date = data.end_date;
          this.form.frequency = data.frequency;
          this.form.no_of_worker = data.no_of_workers;
          this.form.resources = data.resource;
          this.form.image = data.image_url || [];
          this.form.video = data.video_url;
          this.form._id = data._id;
          this.form.activity_status = data.current_status;
          this.form.progress = data.progress;
          this.originalForm = JSON.parse(JSON.stringify(this.form));
        }
      });
    },

    isFormEqual(form1, form2) {
      const simpleFields = [
        '_activityTypeID', 'description', 'start_date', 'end_date',
        'frequency', 'no_of_worker', 'resources', 'assignment_level',
        'notification', 'visible', 'activity_status', 'progress'
      ];
      for (const field of simpleFields) {
        if (form1[field] !== form2[field]) {
          return false;
        }
      }
      if (form1.image.length !== form2.image.length) {
        return false;
      }
      for (let i = 0; i < form1.image.length; i++) {
        if (form1.image[i] !== form2.image[i]) {
          return false;
        }
      }
      if (form1.image_url.length !== form2.image_url.length) {
        return false;
      }
      for (let i = 0; i < form1.image_url.length; i++) {
        if (form1.image_url[i] !== form2.image_url[i]) {
          return false;
        }
      }

      return true;
    },

    removeImage(index) {
      this.form.image.splice(index, 1);
    },

    uploadImage() {
      let formData = new FormData();
     
      var files = this.$refs.multifileupload.files;
      let file_count = this.form.image.length;
      
      if (!files.length)
      return;
      var totalfiles = this.$refs.multifileupload.files.length;
     
      for (var index = 0; index < totalfiles; index++) {
     
        file_count++;
        if(file_count <= 5) {
          formData.append("files", files[index]);
          
        }else{
          alert("Maximum file can be uploaded is 5");
          return;
        }
         
      }
       axios.post('/upload',formData)
       .then(resp => {
          console.log(resp);
          if(resp.data.success){
            for (var index = 0; index < resp.data.data.length; index++) {
              this.form.image.push(resp.data.data[index].url);
              }
          }
       })
    },

    uploadVideo(){
      axios.post('/upload',{
        files: this.$refs.file1.files[0]
       })
       .then(resp => {
          console.log(resp);
          this.form.video = resp.data.data;
       })
    },

    getActivityType() {
      window.axios.get('activity-type').then((resp) => {
        this.activitiesTypes = resp.data.data;
      });
    },

    submitForm() {
       
        // let formData = new FormData();
        // formData.append('_activityTypeID', this.form._activityTypeID);
        // formData.append('description', this.form.description);
        // formData.append('start_date', this.form.start_date);
        // formData.append('end_date', this.form.end_date);
        // formData.append('frequency', this.form.frequency);
        // formData.append('no_of_worker', this.form.no_of_worker);
        // formData.append('image', this.form.image);
        // formData.append('assignment_level', this.form.assignment_level);
        // formData.append('notification', this.form.notification);
        // formData.append('visible', this.form.visible);
        // formData.append('activity_status', this.form.activity_status);
        // formData.append('progress', this.form.progress);
        // formData.append('_id', this.form._id);
        
      window
        .axios({
          method: 'PUT',
          url: 'work-orders',
          data: this.form
        })
        .then((resp) => {
          if (resp.data.success) {
            this.success = resp.data.message;
            console.log(resp.data.success);
            this.$emit('create', resp.data);
          
            this.originalForm = JSON.parse(JSON.stringify(this.form));
            this.isApproveDisable = false;
          }
        });
    },

    approveForm() {

 let id=this.$route.params.workOrderId
      let resp = confirm(
        "Are you sure want to approve the work order?"
      );

      if (resp) {
        this.isBusy = true;
        window.axios
          .post("/work-orders/" + id + "/approve")
          .then((resp) => {
            if (resp.data.success) {
              alert("Work Order is Approved");
              window.location.reload();
              this.isBusy = false;
            } else {
              this.isBusy = false;
            }
          })
          .catch((error) => {
            console.log(error);
            this.isBusy = false;
          });
      } else {
        alert("rejected");
      }
    
    }
  },
};
</script>